import { useAtom } from 'jotai';

import { ConditionalRender } from '@crossnokaye/ux-common';

import { useAutoExpandSearch } from '@/features/trends/components/selections-sidebar/hooks/use-auto-expand-search';
import { useSelectionGroups } from '@/features/trends/components/selections-sidebar/hooks/use-selection-groups';
import {
  SelectionsDeviceGroup,
  SidebarAccordionItem,
} from '@/features/trends/components/selections-sidebar/selections.types';
import SelectionState from '@/features/trends/components/selections-sidebar/state/selections.state';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/ux-common/components/accordion/accordion';
import { Badge } from '@/ux-common/components/badge/badge';
import { Header, HeaderIcon, HeaderTitle } from '@/ux-common/components/header/header';
import { Typography } from '@/ux-common/components/typography/typography';

import { EmptySelectionsList } from './empty-selections-list';
import { SelectionsListGrouping } from './selections-list-grouping';

export const SelectionsList = () => {
  const [expandedSectionIds, setExpandedSectionIds] = useAtom(SelectionState.expandedSectionIds);
  const selectionGroups = useSelectionGroups();

  useAutoExpandSearch(selectionGroups);

  return (
    <Accordion type={'multiple'} value={expandedSectionIds} onValueChange={setExpandedSectionIds}>
      {selectionGroups.map((item: SidebarAccordionItem<SelectionsDeviceGroup>) => (
        <AccordionItem key={item.value} value={item.value}>
          <AccordionTrigger>
            <Header>
              <HeaderIcon>
                <Badge className="badge-pill badge-sm">{item.data.devices.length}</Badge>
              </HeaderIcon>
              <HeaderTitle>
                <Typography as="span" className="text-count-header truncate">
                  {item.title}
                </Typography>
              </HeaderTitle>
            </Header>
          </AccordionTrigger>
          <AccordionContent>
            <SelectionsListGrouping item={item} />
          </AccordionContent>
        </AccordionItem>
      ))}
      <ConditionalRender condition={selectionGroups.length === 0}>
        {EmptySelectionsList && <EmptySelectionsList />}
      </ConditionalRender>
    </Accordion>
  );
};
